import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Stack, Typography, Button } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import PageBanner from "../orderStatus/components/pageBanner";
import Panel from "../orderStatus/components/whitePanel";
import Copyright from "../Copyright";
import "../orderStatus/orderDetail.css";

export default function NoReferenceResults({ reference, error }) {
    const navigate = useNavigate();

    return (
        <Box className="NewOrder">
            <PageBanner title="PARCEL STATUS" subheading="Track Not Found" />
            <Container maxWidth="lg">
                <div id="pageContent" style={{ marginTop: "-48px" }}>
                    <Panel>
                        <Stack alignItems="center" spacing={2} sx={{ py: 6, textAlign: "center" }}>
                            <SearchOffIcon sx={{ fontSize: 56, color: "text.disabled" }} />
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                {error ? "Something went wrong" : "No deliveries found"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
                                {error
                                    ? "We couldn't complete that search. Please try again in a moment."
                                    : <>We couldn't find any deliveries for reference <strong>{reference}</strong>. Double check the reference number and try again.</>}
                            </Typography>
                            <Button variant="contained" color="primary" onClick={() => navigate("/tracking")} sx={{ mt: 1 }}>
                                Track Another Shipment
                            </Button>
                        </Stack>
                    </Panel>
                </div>
            </Container>
            <footer>
                <Copyright />
            </footer>
        </Box>
    );
}
